<template>
  <v-container>
    <v-row>
      
      <v-col cols=12>
        <v-btn block large rounded @click="changeDisplay"><v-icon left>{{ btnIcon }}</v-icon> {{ btnName }}</v-btn>
      </v-col>

      <v-col cols=12 v-if="trueConf">
        <div v-show="!iframe.loaded">
          <v-progress-linear indeterminate color="teal"></v-progress-linear>
        </div>
        <iframe :src="iframe.src" frameborder="0" width="100%" height="800px" @load="iframeLoaded"></iframe>
      </v-col>
      
      <template v-else>

        <v-col md="4">
          <v-card class="mx-auto" max-width="400">

            <v-img class="white--text align-end" src="https://firebasestorage.googleapis.com/v0/b/conf-bakinity1.appspot.com/o/static%2Ftea.jpg?alt=media&token=edbfbb48-9696-4e6d-840d-a8d3380be2d5">
              <v-card-title>Кофе (американо)</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="4">
                  <v-btn small block color="error" @click="coffee--" >-</v-btn>
                </v-col>
                <v-col cols="4" class="text-center">
                  <h1>{{ coffee }}</h1>
                </v-col>
                <v-col cols="4">
                  <v-btn small block color="orange" @click="coffee++" >+</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>

        <v-col md="4">
          <v-card class="mx-auto" max-width="400">

            <v-img class="white--text align-end" src="https://firebasestorage.googleapis.com/v0/b/conf-bakinity1.appspot.com/o/static%2Fwater.jpg?alt=media&token=a510b0be-4261-45b2-a557-75aa15c9c6a8">
              <v-card-title>Чай (чёрный)</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="4">
                  <v-btn small block color="error" @click="tea--" >-</v-btn>
                </v-col>
                <v-col cols="4" class="text-center">
                  <h1>{{ tea }}</h1>
                </v-col>
                <v-col cols="4">
                  <v-btn small block color="orange" @click="tea++" >+</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>

        <v-col md="4">
          <v-card class="mx-auto" max-width="400">

            <v-img class="white--text align-end" src="https://firebasestorage.googleapis.com/v0/b/conf-bakinity1.appspot.com/o/static%2Fwater.jpg?alt=media&token=a510b0be-4261-45b2-a557-75aa15c9c6a8">
              <v-card-title>Вода (без газа)</v-card-title>
            </v-img>

            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="4">
                  <v-btn small block color="error" @click="water--" >-</v-btn>
                </v-col>
                <v-col cols="4" class="text-center">
                  <h1>{{ water }}</h1>
                </v-col>
                <v-col cols="4">
                  <v-btn small block color="orange" @click="water++" >+</v-btn>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-col>
        
        <v-col cols-12>
          <v-btn block large color="success" @click="onCreateOrder">Заказать</v-btn>
        </v-col>

      </template>

      <v-overlay :value="loadingStatus">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-snackbar v-model="snackbar">
        Спасибо! Ваш заказ принят.
      </v-snackbar>

    </v-row>
  </v-container>
</template>

<script>
  
  export default {
    data: () => ({
      timestamp: '',
      water: 0,
      coffee: 0,
      tea: 0,
      snackbar: false,
      snackbarStatus: false,
      trueConf: false,
      btnName: 'trueConf',
      btnIcon: 'mdi-account-group',
      iframe: {
        src: 'http://192.168.0.27/main',
        loaded: false
      }
    }),
    methods: {
      onCreateOrder(){
        const newOrder = {
            room: this.$route.params.room,
            timestamp: new Date().getTime(),
            water: this.water,
            coffee: this.coffee,
            tea: this.tea,
        };
        this.$store.dispatch('createOrder', newOrder);
        this.water = this.coffee = this.tea = 0;
        this.snackbarStatus = true;
      },
      changeDisplay(){
        if(this.$route.params.room == 'room2'){
          this.iframe.src = 'http://192.168.0.35/main';
        }
        this.trueConf = !this.trueConf;
        this.btnName = this.trueConf ? 'заказ' : 'trueConf';
        this.btnIcon = this.trueConf ? 'mdi-tea-outline' : 'mdi-account-group';
        this.iframe.loaded = false;
      },
      iframeLoaded(){
        console.log('iframeLoaded');
        this.iframe.loaded = true;
      }
    },
    computed: {
      loadingStatus(){
        return this.$store.state.loading;
      }
    },
    watch: {
      loadingStatus: function(){
        if(!this.loadingStatus && this.snackbarStatus){
          this.snackbar = true;
        }
      }
    }
  }

</script>
